// TODO: NOT FINISHED TYPES NEED TO BEF FIXED
import { StencilComponentBuilder } from '../stecil-component-builder';
import { StringService } from '../../services/string';
import components from '../../components/custom';

type CustomComponentsType = keyof typeof components;

const customComponents: Record<string, CustomComponentsType> = Object.keys(components).reduce(
  (accumulator, componentName) => {
    const CustomComponent = components;
    const kebabName = StringService.camelToKebab(componentName);
    accumulator[kebabName] = CustomComponent[componentName as CustomComponentsType];
    return accumulator;
  },
  {} as { [key: string]: any },
);

// if set return type to customComponentsType =>
// blok-to-component CustomChild cannot read custom components
export const getComponent = (type: string): any => customComponents[type] || StencilComponentBuilder;
